/**
 * Given a Legacy IVR coming from the backend
 * This method does an In-Order tree traversal to calculate the x & y of each node
 * By traveling this way it will set an approximate value to each node that makes the legacy IVR tree (without coordinates) look good
 * @param {*} ivrTree Object from the backend
 * @returns the same IVR Tree but its nodes will have they x & y coordinates modified.
 */
export function beautyfyLegacyIVRTree(ivrTree) {

  // Position the root node left aligned at the beginning of the tree
  const xStart = 0;
  const yStart = 0;

  ivrTree.root.posX = xStart;
  ivrTree.root.posY = yStart;

  const nodeMap = ivrTree.nodes;

  let children = ivrTree.root.childLinks.map((child) => {
    return {
      id: child.childNodeId,
      x: xStart + 350,
    };
  });
  let nodesToVisit = [...children];
  let y = yStart - 50;
  while (nodesToVisit.length > 0) {
    const nodeToVisitData = nodesToVisit.shift();
    const nodeToVisit = nodeMap[nodeToVisitData.id];
    nodeToVisit.node.posX = nodeToVisitData.x;
    nodeToVisit.node.posY = y;
    if (nodeToVisit.childLinks.length > 0) {

      if (nodeToVisit.node.nodeTypeId == 'GoToNode') {
        const failureNode = nodeToVisit.childLinks.find((n) => n.name == 'OnFailure');
        if (failureNode) {
          nodesToVisit = [{ id: failureNode.childNodeId, x: nodeToVisit.node.posX + 450 }, ...nodesToVisit];
        }
      }
      else {
        // Find failure nodes and move to end of the array to enhance the visual order of the tree
        const childLinksSorted = nodeToVisit.childLinks;
        childLinksSorted.forEach((n) => {
          if (n.name === 'OnFailure') {
            childLinksSorted.push(childLinksSorted.splice(childLinksSorted.indexOf(n), 1).pop());
          }
        });
        children = childLinksSorted.map((child) => {
          return {
            id: child.childNodeId,
            x: nodeToVisit.node.posX + 450,
          };
        });
        nodesToVisit = [...children, ...nodesToVisit];
      }

    } else {
      y += 200;
    }
  }
  return ivrTree;
}

/**
 * Given a Backend IVR Tree checks it's node coordinates to decide if it's a legacy tree or if should be considered a call flow
 * @param {*} ivrTree Object from the backend
 * @returns true if all the nodes coordinates are 0, false in any other case
 */
export function isLegacyIVRTree(ivrTree) {
  const nodeMap = ivrTree.nodes;

  return Object.values(nodeMap).every(nodeValue => nodeValue.node.posX == 0 && nodeValue.node.posY == 0);
}